import React, { useEffect, useRef } from 'react';
import { adsApi } from '../../api/ads';
const delivered = new Set();
export function visibleSponsoredEntry(entry) {
  const box = entry.boundingClientRect,
    visible = entry.intersectionRect;
  return (
    entry.isIntersecting &&
    box.width > 0 &&
    box.height > 0 &&
    visible.width / box.width >= 0.5 &&
    visible.height / box.height >= 0.5
  );
}
export default function SponsoredExposure({ campaignId, placementKey, children, className }) {
  const ref = useRef(null);
  useEffect(() => {
    const node = ref.current;
    if (!node || typeof IntersectionObserver === 'undefined') return;
    const key = `${campaignId}:${placementKey}`;
    const observer = new IntersectionObserver(
      (entries) => {
        if (document.hidden || delivered.has(key) || !entries.some(visibleSponsoredEntry)) return;
        delivered.add(key);
        void adsApi.impression(campaignId, placementKey).catch(() => delivered.delete(key));
      },
      { threshold: [0, 0.25, 0.5, 0.75, 1], rootMargin: '-60px 0px -80px 0px' },
    );
    observer.observe(node);
    const resume = () => {
      if (!document.hidden) {
        observer.unobserve(node);
        observer.observe(node);
      }
    };
    document.addEventListener('visibilitychange', resume);
    return () => {
      observer.disconnect();
      document.removeEventListener('visibilitychange', resume);
    };
  }, [campaignId, placementKey]);
  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
}
